import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!ok) return toast.error("Serve il consenso per iscriverti.");
    setBusy(true);
    try { await axios.post(`${API}/api/newsletter/subscribe`, { email, consenso: true }); setDone(true); }
    catch (err) { toast.error(err.response?.data?.detail || "Iscrizione non riuscita, riprova."); }
    finally { setBusy(false); }
  };
  if (done) return <p className="text-sm text-[#86C89B]" data-testid="newsletter-done">Quasi fatto: controlla la tua email e conferma l'iscrizione.</p>;
  return (
    <form onSubmit={submit} data-testid="newsletter-form">
      <div className="flex gap-2">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="La tua email" data-testid="newsletter-email-input"
          className="flex-1 min-w-0 rounded-full bg-[#FCFBF7]/10 border border-[#FCFBF7]/15 px-5 py-3 text-base text-[#FCFBF7] placeholder:text-[#FCFBF7]/50 outline-none focus:border-[#86C89B]" />
        <button type="submit" disabled={busy} data-testid="newsletter-submit-btn" aria-label="Iscriviti" className="grid place-items-center w-12 h-12 shrink-0 rounded-full bg-[#86C89B] text-[#0F2317] hover:bg-[#FCFBF7] transition-colors">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <ArrowRight size={16} />}
        </button>
      </div>
      <label className="mt-3 flex items-start gap-2 text-xs text-[#FCFBF7]/70">
        <input type="checkbox" checked={ok} onChange={(e) => setOk(e.target.checked)} className="mt-0.5 w-5 h-5 shrink-0 accent-[#86C89B]" data-testid="newsletter-consent" />
        Acconsento a ricevere la newsletter, come descritto nella Privacy Policy. Puoi disiscriverti con un clic.
      </label>
    </form>
  );
};
